'use strict';

export default function f($rootScope, $q, $http, utils, userModel) {
  'ngInject';
  function getApiUrl() {
    return utils.getApiUrl(`/reviews/${userModel.item.id}/feedback`);
  }

  return {
    rate: function (rateData) {
      return $http.post(getApiUrl(), rateData);
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/services/rate_service.js